import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useMall } from "@/context/MallContext";

/**
 * /site/:slug used to be a second page for the same shop. There is one shop page now:
 * /stores/:slug. Old links land there. (A shop's own domain still serves the shop at `/`.)
 */
export default function SiteEntry() {
    const { slug } = useParams();
    return <Navigate to={slug ? `/stores/${slug}` : "/directory"} replace />;
}

/** /site/exit — leave a shop's own site or the demo and go back to the directory. */
export function SiteExit() {
    const { exitSolo } = useMall();
    useEffect(() => { exitSolo(); }, [exitSolo]);
    return <Navigate to="/directory" replace />;
}
